const DB_NAME = "ppt-cache-db";
const STORE_NAME = "ppt-entries";
const DB_VERSION = 1;

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(req.error);
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (evt) => {
      const db = (evt.target as IDBOpenDBRequest).result as IDBDatabase;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    };
  });
}

async function withStore<T>(
  mode: IDBTransactionMode,
  cb: (store: IDBObjectStore) => Promise<T> | T
): Promise<T> {
  const db = await openDB();
  return new Promise<T>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, mode);
    const store = tx.objectStore(STORE_NAME);
    Promise.resolve()
      .then(() => cb(store))
      .then((res) => {
        tx.oncomplete = () => resolve(res);
        tx.onabort = tx.onerror = () =>
          reject(tx.error || new Error("Transaction failed"));
      })
      .catch((err) => reject(err));
  });
}

export async function savePptToCache(
  templateId: string,
  blob: Blob
): Promise<void> {
  if (!templateId) return;
  const entry = {
    id: templateId,
    blob,
    cachedAt: new Date().toISOString(),
  } as any;
  await withStore("readwrite", (store) => {
    store.put(entry);
  });
}

export async function getPptFromCache(
  templateId: string
): Promise<Blob | null> {
  if (!templateId) return null;
  const db = await openDB();
  return new Promise<Blob | null>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const req = store.get(templateId);
    req.onsuccess = () => {
      const val = req.result;
      if (val && val.blob) resolve(val.blob as Blob);
      else resolve(null);
    };
    req.onerror = () => reject(req.error);
  });
}

export async function deletePptFromCache(templateId: string): Promise<void> {
  if (!templateId) return;
  await withStore("readwrite", (store) => {
    store.delete(templateId);
  });
}

export async function clearPptCache(): Promise<void> {
  await withStore("readwrite", (store) => {
    store.clear();
  });
}

export async function listCachedTemplateIds(): Promise<string[]> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const req = store.getAllKeys();
    req.onsuccess = () => resolve(req.result as string[]);
    req.onerror = () => reject(req.error);
  });
}
